let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("mf86l")).then(() => parcelRequire('ksdj2'));